// ─────────────────────────────────────────────────────────────────────────────
// ProdVenueSpecs, the Production secondary strip (movers slot). The 5 venue-spec
// tiles (Soundcheck / Monitors / Backline / Load-in / FOH eng) + the top crew
// notes, from the crowd-sourced venue record. Read-only port; the Edit-specs /
// Crew-note write modals are a follow-up.
// ─────────────────────────────────────────────────────────────────────────────

import type { JSX } from 'react';
import { useProductionSpotlight } from '../../lib';

export function ProdVenueSpecs(): JSX.Element {
  const { data } = useProductionSpotlight();
  const tiles: ReadonlyArray<{ k: string; label: string; value: string }> = [
    { k: 'SC', label: 'Soundcheck', value: data.soundcheck },
    { k: 'MON', label: 'Monitors', value: data.monitors },
    { k: 'BL', label: 'Backline', value: data.backline },
    { k: 'LD', label: 'Load-in', value: data.loadin },
    { k: 'FOH', label: 'House eng', value: data.houseEng },
  ];

  return (
    <section aria-labelledby="prod-specs-label">
      <div className="section-label">
        <h3 className="section-label__title" id="prod-specs-label">Venue specs</h3>
        <span className="section-label__meta">{data.footerLabel.toUpperCase()}</span>
      </div>

      <ul className="prod-specs">
        {tiles.map((t) => (
          <li className="prod-spec" key={t.k}>
            <span className="prod-spec__badge">{t.k}</span>
            <div className="prod-spec__body">
              <span className="prod-spec__label">{t.label}</span>
              <span className="prod-spec__value">{t.value}</span>
            </div>
          </li>
        ))}
      </ul>

      {data.notes.length > 0 && (
        <ul className="prod-notes">
          {data.notes.map((n) => (
            <li className="prod-note" key={n.id}>
              <span className="prod-note__tag">Crew tip</span>
              <span className="prod-note__text">{n.note}</span>
              <span className="prod-note__attr">{n.band}</span>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
